export class CurrentTopic {
  constructor(
    public id: number,
    public name: string,
    public myCompanyName: string,
    public topicQuery: string,
    public isMyCompany: boolean
  ) {}
}
